/** Збереження результату й стану зв'язку: тост «збережено» і відмова сервера. */
export const outcome = {
  saved: (title: string) => `${title}: збережено`,
  saveFailed: 'Не вдалося зберегти: сервер не відповів',
} as const;
